export default "__VITE_ASSET__be954dbf__"